import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserRule } from '@verify/shared-components/models';
import { AuthService } from '@verify/shared-components/services';
import { map, take } from 'rxjs';
import { AssetService } from '../services';

export const assetGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const assetService: AssetService = inject(AssetService);
  const router: Router = inject(Router);

  const assetId = route.params['assetId'];
  if (assetId) {
    return assetService.getAsset(assetId).pipe(
      take(1),
      map((asset) => {
        if (!asset || asset.deleted) {
          return router.parseUrl('error?code=404');
        } else {
          const { id, rules, groupIds } = authService.currentUser;
          const isAssetAdmin = rules.includes(UserRule.projectAdmin);
          if (
            isAssetAdmin ||
            asset.createdBy === id ||
            !asset.groupIds?.length ||
            asset.groupIds.some((gid) => groupIds.includes(gid))
          ) {
            return true;
          } else {
            return router.parseUrl('error?code=403');
          }
        }
      }),
    );
  }
  return router.parseUrl('error?code=404');
};
